import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { useDeviceSize } from '@hooks';
import { PriceDisplay } from '@components/price-display';
import { Popup } from '@elements';
import { StyledButton, StyledContent, StyledHeader, StyledPopup } from './place-reserve.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlaceReservePopup = function PlaceReservePopup(_ref) {
  var _popUp$data, _popUp$data$data, _popUp$data2, _popUp$data2$data, _popUp$data$data$fina, _popUp$data3, _popUp$data3$data, _popUp$data4, _popUp$data4$data, _popUp$data5, _popUp$data5$data, _popUp$data6, _popUp$data6$data, _basket$quantity;

  var popUp = _ref.popUp,
      rejectPopup = _ref.rejectPopup,
      acceptPopup = _ref.acceptPopup;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
  var place = popUp === null || popUp === void 0 ? void 0 : (_popUp$data = popUp.data) === null || _popUp$data === void 0 ? void 0 : (_popUp$data$data = _popUp$data.data) === null || _popUp$data$data === void 0 ? void 0 : _popUp$data$data.place; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

  var price = popUp === null || popUp === void 0 ? void 0 : (_popUp$data2 = popUp.data) === null || _popUp$data2 === void 0 ? void 0 : (_popUp$data2$data = _popUp$data2.data) === null || _popUp$data2$data === void 0 ? void 0 : _popUp$data2$data.price; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

  var finalPrice = (_popUp$data$data$fina = popUp === null || popUp === void 0 ? void 0 : (_popUp$data3 = popUp.data) === null || _popUp$data3 === void 0 ? void 0 : (_popUp$data3$data = _popUp$data3.data) === null || _popUp$data3$data === void 0 ? void 0 : _popUp$data3$data.finalPrice) !== null && _popUp$data$data$fina !== void 0 ? _popUp$data$data$fina : price; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any

  var onSeatReserve = popUp === null || popUp === void 0 ? void 0 : (_popUp$data4 = popUp.data) === null || _popUp$data4 === void 0 ? void 0 : (_popUp$data4$data = _popUp$data4.data) === null || _popUp$data4$data === void 0 ? void 0 : _popUp$data4$data.onSeatReserve; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any

  var onSeatUnreserve = popUp === null || popUp === void 0 ? void 0 : (_popUp$data5 = popUp.data) === null || _popUp$data5 === void 0 ? void 0 : (_popUp$data5$data = _popUp$data5.data) === null || _popUp$data5$data === void 0 ? void 0 : _popUp$data5$data.onSeatUnreserve; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any

  var basket = popUp === null || popUp === void 0 ? void 0 : (_popUp$data6 = popUp.data) === null || _popUp$data6 === void 0 ? void 0 : (_popUp$data6$data = _popUp$data6.data) === null || _popUp$data6$data === void 0 ? void 0 : _popUp$data6$data.basket;

  var _useDeviceSize = useDeviceSize(),
      mobile = _useDeviceSize.mobile;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t; // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access


  var _useState = useState((_basket$quantity = basket === null || basket === void 0 ? void 0 : basket.quantity) !== null && _basket$quantity !== void 0 ? _basket$quantity : 0),
      _useState2 = _slicedToArray(_useState, 2),
      reservedQuantity = _useState2[0],
      setReservedQuantity = _useState2[1];

  var _useState3 = useState(place.reserveLimit ? place.reserveLimit - place.reservedQuantity : 0),
      _useState4 = _slicedToArray(_useState3, 2),
      reselveLimit = _useState4[0],
      setReselveLimit = _useState4[1];

  var withoutLimit = place.reserveLimit === null || place.reserveLimit === undefined;
  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 456,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Typography, {
          variant: mobile ? 'h5' : 'h4',
          color: "#ffffff",
          fontWeight: 700,
          children: "".concat(place.prefix, " ").concat(place.name).concat(reselveLimit && !withoutLimit ? " ".concat(t('pages.sector.available'), ": ").concat(reselveLimit) : '')
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsx(StyledContent, {
        flexDirection: "column",
        children: /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsx(PriceDisplay, {
              basePrice: price,
              finalPrice: finalPrice,
              fontWeight: 500
            })
          }), /*#__PURE__*/_jsxs(Stack, {
            gap: 2,
            direction: "row",
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(StyledButton, {
              variant: "contained",
              color: "secondary",
              size: "medium",
              disabled: !reservedQuantity,
              onClick: function onClick() {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                onSeatUnreserve(place)().then(function () {
                  setReservedQuantity(function (count) {
                    return count - 1;
                  });
                  setReselveLimit(function (count) {
                    return count + 1;
                  });
                })["catch"](function () {// error
                });
              },
              children: "-"
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "h4",
              color: "#ffffff",
              fontWeight: 500,
              children: reservedQuantity
            }), /*#__PURE__*/_jsx(StyledButton, {
              variant: "contained",
              size: "small",
              disabled: reservedQuantity > reselveLimit && !withoutLimit,
              onClick: function onClick() {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                onSeatReserve(place)().then(function () {
                  setReservedQuantity(function (count) {
                    return count + 1;
                  });
                  setReselveLimit(function (count) {
                    return count - 1;
                  });
                })["catch"](function () {// error
                });
              },
              children: "+"
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Footer, {
      children: /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        width: "100%",
        children: /*#__PURE__*/_jsx(StyledButton, {
          variant: "contained",
          color: "secondary",
          size: "medium",
          fullWidth: true,
          onClick: rejectPopup,
          children: t('components.popups.close')
        })
      })
    })]
  });
};

export { PlaceReservePopup };